import { Seo } from "@/components/site/Seo";
import { Hero } from "@/components/site/Hero";
import { Heartbeat } from "@/components/site/Heartbeat";
import { Pillars } from "@/components/site/Pillars";
import { BrandMarquee } from "@/components/site/BrandMarquee";
import { Certifications } from "@/components/site/Certifications";
import { Fgas } from "@/components/site/Fgas";
import { Courses } from "@/components/site/Courses";
import { PrenotaCTA } from "@/components/site/PrenotaCTA";
import { TrustpilotReviews } from "@/components/site/TrustpilotReviews";
import { Contact } from "@/components/site/Contact";

export default function Home() {
  return (
    <>
      <Seo
        title="Centro di Formazione a Frosinone | treffe — Consulenza 81/08, FGAS, corsi BLS-D"
        description="Centro di formazione a Frosinone: consulenza D.Lgs 81/08, certificazioni FGAS, supporto bandi regionali e corsi BLS-D/AHA. Non vendiamo un prodotto, vendiamo un servizio."
        path="/"
      />
      <Hero />
      <div className="bg-brand-black py-5">
        <Heartbeat height={48} />
      </div>
      <Pillars />
      <BrandMarquee />
      <Certifications />
      <Fgas />
      <Courses />
      <TrustpilotReviews />
      <PrenotaCTA />
      <Contact showMap={false} />
    </>
  );
}
